import React, { useState, useEffect } from "react";

import useModal from "@hooks/useModal";
import ArrowIconDown from "@images/fillInTable/fillintable-search-arrow-down.svg";
import ArrowIconUp from "@images/fillInTable/fillintable-search-arrow-up.svg";
import SearchIconSky from "@images/fillInTable/search-icon-24-size-sky.svg";
import FillInTableArticleTable from "@molecules/FillInTableArticleTable/FillInTableArticleTable";
import FillInTableArticleTableModal from "@molecules/FillInTableArticleTableModal/FillInTableArticleTableModal";

import * as S from "./FillInTableArticleTableContainer.style";

import type { ParsedJsonTableContentType } from "@/types/fillInTableContent.types";

interface Props {
  item: ParsedJsonTableContentType;
  searchTerm?: string;
  currentSearchIndex?: number;
  onSearchResultsCount?: (count: number) => void;
  onSearchRangesUpdate?: (
    ranges: Array<[number, number, string[], number]>,
  ) => void;
  tableIndex?: number;
}

const FillInTableArticleTableContainer = React.memo(
  ({
    item,
    searchTerm,
    currentSearchIndex,
    onSearchResultsCount,
    onSearchRangesUpdate,
    tableIndex,
  }: Props) => {
    const { openModal, closeModal, isModal } = useModal();
    const [isShowContent, setIsShowContent] = useState(false);

    useEffect(() => {
      if (searchTerm && item.html) {
        const hasSearchTerm = item.html
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
        if (hasSearchTerm) {
          setIsShowContent(true);
        }
      }
    }, [searchTerm, item.html]);

    return (
      <S.FillInTableContainer isShowContent={isShowContent}>
        <button
          type="button"
          onClick={() => setIsShowContent(!isShowContent)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
        >
          <S.FillInTableContainerHeadLine>
            <S.FillInTableContainerTitle>
              Press Table
              {isShowContent ? (
                <img src={ArrowIconUp} alt="search-arrow-up" />
              ) : (
                <img src={ArrowIconDown} alt="search-arrow-down" />
              )}
            </S.FillInTableContainerTitle>
            <S.FillInTableContainerExpandViewText
              onClick={(e) => {
                openModal();
                e.stopPropagation();
              }}
            >
              <span>Expand View</span>
              <img src={SearchIconSky} alt="search-icon" />
            </S.FillInTableContainerExpandViewText>
          </S.FillInTableContainerHeadLine>
        </button>
        <S.FillInTableContentContainer>
          <FillInTableArticleTable
            item={item}
            searchTerm={searchTerm}
            currentSearchIndex={currentSearchIndex}
            onSearchResultsCount={onSearchResultsCount}
            onSearchRangesUpdate={onSearchRangesUpdate}
            tableIndex={tableIndex}
          />
        </S.FillInTableContentContainer>
        {isModal && (
          <FillInTableArticleTableModal item={item} closeModal={closeModal} />
        )}
      </S.FillInTableContainer>
    );
  },
);

export default FillInTableArticleTableContainer;
